import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greys.light};
  border-radius: ${({ theme }) => theme.borders.radius.weak};
`;

export const IdentityColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Fixed width across rows so the progress bars line up vertically regardless of how many
     stores wrap onto multiple lines per row. */
  width: 280px;
  flex-shrink: 0;
`;

export const IdentityTitle = styled.span`
  font: ${({ theme }) => theme.fonts.textBigHeight24Bold};
  color: ${({ theme }) => theme.colors.greys.darkest};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StoreListText = styled.span`
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
  color: ${({ theme }) => theme.colors.greys.darker};
  /* Long store lists must wrap onto multiple lines instead of overflowing the column. */
  white-space: normal;
  overflow-wrap: anywhere;
  cursor: default;
`;

export const ChannelsColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const ChannelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const ChannelLabel = styled.span`
  font: ${({ theme }) => theme.fonts.textMiddleNormal};
  color: ${({ theme }) => theme.colors.greys.darker};
  min-width: 96px;
  flex-shrink: 0;
`;

export const ProgressArea = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const AmountOverlay = styled.span`
  position: absolute;
  top: 4px;
  /* Beyond 91% the value can clip the dot, mirror the lib's percentage placement rule. */
  left: ${({ $percentage }) => {
    if ($percentage > 91) {
      return `calc(${$percentage}% - 90px)`;
    }

    return `calc(${$percentage}% + 8px)`;
  }};
  font: ${({ theme }) => theme.fonts.textMicroHeight16Weight700Bold};
  color: ${({ theme }) => theme.colors.black};
  pointer-events: none;
  white-space: nowrap;
`;

export const TooltipRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
`;

export const TooltipLabel = styled.span`
  color: ${({ theme }) => theme.colors.greys.darker};
`;

export const TooltipValue = styled.span`
  color: ${({ theme }) => theme.colors.greys.darkest};
  font-weight: 600;
`;

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
  padding: 4px 8px;
`;
